import { application } from "./application"
import CarouselController from "./carousel_controller"
import ExportController from "./export_controller"
import Ts3ReviewController from "./ts3_review_controller"

application.register("carousel", CarouselController)
application.register("export", ExportController)
application.register("ts3-review", Ts3ReviewController)
